import { Box, Flex, SimpleGrid } from '@chakra-ui/core';
import React from 'react';
// eslint-disable-next-line import/named
import { ParentPartitionKeyCheckBox, PartitionKeyCheckBox } from './DynamicComparison';

const FundamentalComparison: React.FC = () => {
  return (
    <SimpleGrid mt={8} columns={2} gridColumnGap={12} gridRowGap={8}>
      <Box>
        <ParentPartitionKeyCheckBox
          keys={['bond-global', 'bond-us', 'bond-eu', 'bond-germany', 'bond-france', 'bond-belgium']}
          label="Obligaties"
        />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox
            partitionKey="bond-global"
            label="Bloomberg Global Aggregate Bond UCITS ETF Hedged (EUR)"
          />
          <PartitionKeyCheckBox partitionKey="bond-us" label="10-Year Bond US (USD)" />
          <PartitionKeyCheckBox partitionKey="bond-eu" label="10-Year Bond EUR (EUR)" />
          <PartitionKeyCheckBox partitionKey="bond-germany" label="10-Year Bond Germany (EUR)" />
          <PartitionKeyCheckBox partitionKey="bond-france" label="10-Year Bond France (EUR)" />
          <PartitionKeyCheckBox partitionKey="bond-belgium" label="10-Year Bond Belgium (EUR)" />
        </Flex>
      </Box>
      <Box>
        <ParentPartitionKeyCheckBox keys={['gold']} label="Diversen" />
        <Flex mt={1} pl={6} direction="column" gridGap={2}>
          <PartitionKeyCheckBox partitionKey="gold" label="Gold Futures (USD)" />
        </Flex>
      </Box>
    </SimpleGrid>
  );
};

export default FundamentalComparison;
